module.exports = __webpack_public_path__ + "img/739aff2.jpg";